import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/bootstrap.scss';
import 'bootstrap/dist/js/bootstrap.js';




import AllRoutes from './routes';

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<AllRoutes />);